import { useState } from "react";
import LiveStudents from "./LiveStudents";
import { useQuery } from "react-query";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { developAxios } from "../../axios.config";
import axios, { AxiosError } from "axios";
import AllStudents from "./AllStudents";
import { Badge } from "react-bootstrap";
import { IExamState } from "../hoc/stdLiveWrapper";
import { SOCKET_DATA } from "../../env";

export default function StudentDataHybrid({
	setLiveStudents,
	setEnrolledStudents,
	setSubmittedUsers,
	changeExamDate,
	submittedCount,
	unSubmittedCount,
	changeExamState,
	changeExamData,
}: IExamState) {
	const [tab, setTab] = useState<number>(1);
	const [searchValue, setSearchValue] = useState<string>("");
	const { _id } = useParams<{ _id: string }>();
	const [disableExportButton, setDisableExportButton] =
		useState<boolean>(false);
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const history = useHistory();

	const badgeStyle = {
		color: "#000",
		border: "1px solid #000",
		borderRadius: "999px",
		fontSize: "0.8rem",
		height: "2.0rem",
		width: "2.0rem",
	};

	function downloadFile(tab: number) {
		const type = tab === 2 ? "submitted" : "unsubmitted";
		const examType = queryParams.get("type");

		setDisableExportButton(true);
		fetch(
			`${process.env.REACT_APP_BASE_URL}/${
				tab === 2
					? `hybrid-exam/downloadSubmittedUsersByExamId`
					: `hybrid-exam/downloadUnSubmittedUsersByExamId`
			}/${_id}`,
			{
				headers: {
					Authorization: `Bearer ${
						localStorage.getItem("token") || ""
					}`,
				},
			}
		)
			.then((res) => res.blob())
			.then((blob) => {
				const url = window.URL.createObjectURL(new Blob([blob]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", `${type}_${_id}_file.xlsx`);
				document.body.appendChild(link);
				link.click();
			})
			.catch((err) => {
				alert(`Unable to download file ${type}_${_id}_file.xlsx`);
			})
			.finally(() => setDisableExportButton(false));
	}

	return (
		<div className="SearchNav">
			<ul className="SearchItem mt-1">
				<div className="inline select-none">
					<input
						type="radio"
						name="tab-name"
						value="1"
						id="coding-exam-tab-live"
						onClick={(e) =>
							setTab(
								parseInt((e.target as HTMLInputElement).value)
							)
						}
						checked={1 === tab}
						className="hidden"
					/>
					<label
						className={`cursor-pointer ease-in m-1 rounded border-1 py-1 px-2 ${
							tab === 1 &&
							"bg-yellow-400 text-white font-semibold"
						}`}
						htmlFor="coding-exam-tab-live"
					>
						Live Students
					</label>
				</div>
				<div className="inline select-none">
					<input
						type="radio"
						name="tab-name"
						value="2"
						id="coding-exam-tab-submitted"
						onClick={(e) =>
							setTab(
								parseInt((e.target as HTMLInputElement).value)
							)
						}
						checked={2 === tab}
						className="hidden"
					/>
					<label
						className={`cursor-pointer ease-in m-1 rounded border-1 py-1 px-2 ${
							tab === 2 &&
							"bg-yellow-400 text-white font-semibold"
						}`}
						htmlFor="coding-exam-tab-submitted"
					>
						<span className="flex items-center">
							Submitted Students
							{2 === tab ? (
								<Badge
									bg="light"
									style={badgeStyle}
									className="leading-normal ml-2 flex items-center p-[0px] justify-center"
								>
									{submittedCount}
								</Badge>
							) : (
								<Badge
									bg="warning"
									style={badgeStyle}
									className="leading-normal ml-2 flex items-center p-[0px] justify-center"
								>
									{submittedCount}
								</Badge>
							)}
						</span>
					</label>
				</div>
				<div className="inline select-none">
					<input
						type="radio"
						name="tab-name"
						value="3"
						id="coding-exam-tab-unsubmitted"
						onClick={(e) =>
							setTab(
								parseInt((e.target as HTMLInputElement).value)
							)
						}
						checked={3 === tab}
						className="hidden"
					/>
					<label
						className={`cursor-pointer ease-in m-1 rounded border-1 py-1 px-2 ${
							tab === 3 &&
							"bg-yellow-400 text-white font-semibold"
						}`}
						htmlFor="coding-exam-tab-unsubmitted"
					>
						<span className="flex items-center">
							Unsubmitted students
							{3 === tab ? (
								<Badge
									bg="light"
									style={badgeStyle}
									className="leading-normal ml-2 flex items-center p-[0px] justify-center"
								>
									{unSubmittedCount}
								</Badge>
							) : (
								<Badge
									bg="warning"
									style={badgeStyle}
									className="leading-normal ml-2 flex items-center p-[0px] justify-center"
								>
									{unSubmittedCount}
								</Badge>
							)}
						</span>
					</label>
				</div>
				<div className="inline select-none">
					<input
						type="radio"
						name="tab-name"
						value="4"
						id="coding-exam-tab-all"
						onClick={(e) =>
							setTab(
								parseInt((e.target as HTMLInputElement).value)
							)
						}
						checked={4 === tab}
						className="hidden"
					/>
					<label
						className={`cursor-pointer ease-in m-1 rounded border-1 py-1 px-2 ${
							tab === 4 &&
							"bg-yellow-400 text-white font-semibold"
						}`}
						htmlFor="coding-exam-tab-all"
					>
						All Students
					</label>
				</div>
			</ul>
			<div className="flex flex-col justify-between items-start gap-2 md:gap-0 md:items-center md:flex-row mx-3 sm:mx-0">
				<div className="w-content flex justify-between items-center mt-2 bg-gray-300 py-2 px-3 rounded grow">
					<span className="ml-8 text-gray-800">Search Students</span>
					<div className="searchInput">
						<input
							type="search"
							value={searchValue}
							placeholder="Search"
							autoFocus
							onChange={(e) => setSearchValue(e.target.value)}
							className="rounded-[999px] border-1 border-gray-400 px-3 py-1"
						/>
					</div>
				</div>
				{(tab === 2 || tab === 3) && (
					<button
						disabled={disableExportButton}
						onClick={() => downloadFile(tab)}
						className="inline bg-yellow-500 px-3 rounded text-white font-semibold py-2 md:ml-[5vw] disabled:bg-gray-500"
					>
						Export
					</button>
				)}
			</div>
			<section>
				<ActiveTab
					tab={tab}
					setLiveStudents={setLiveStudents}
					setEnrolledStudents={setEnrolledStudents}
					setSubmittedUsers={setSubmittedUsers}
					changeExamDate={changeExamDate}
					searchValue={searchValue}
					changeExamState={changeExamState}
					changeExamData={changeExamData}
				/>
			</section>
		</div>
	);
}

interface ILiveDataResponse {
	totalStudentsWhoEnrolled: number;
	examDate?: string;
	examStatus: "live" | "ended";
	courseName: string;
	examName: string;
}
function ActiveTab({
	tab,
	setLiveStudents,
	setEnrolledStudents,
	setSubmittedUsers,
	changeExamDate,
	searchValue,
	changeExamState,
	changeExamData,
}: {
	tab: number;
	setLiveStudents: (count: number) => unknown;
	setEnrolledStudents: (count: number) => unknown;
	setSubmittedUsers: (count: number) => unknown;
	changeExamDate: (date_str: string) => unknown;
	changeExamState: (state: "live" | "ended") => unknown;
	searchValue: string;
	changeExamData: (options: {
		courseName: string;
		examName: string;
	}) => unknown;
}) {
	const [submittedData, setSubmittedData] = useState<
		Array<{
			user: {
				email: string;
			};
			_id: string;
			status: "submitted";
		}>
	>([]);
	const [liveStudentData, setLiveStudentData] = useState<
		Array<{
			_id: string;
			user: {
				firstName: string;
				email: string;
			};
		}>
	>([]);
	const [unsubmittedData, setUnsubmittedData] = useState<
		Array<{
			user: {
				firstName: string;
				email: string;
			};
			_id: string;
			status: "unsubmitted";
		}>
	>([]);
	const { _id } = useParams<{ _id: string }>();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const history = useHistory();

	const { data: live_data, isLoading: live_data_loading } = useQuery(
		["live-exams", "get-live-students", _id],
		() =>
			developAxios(
				localStorage.getItem("token") || ""
			).get<ILiveDataResponse>(
				`/live-exams/get-live-students/${_id}?type=hybrid`
			),
		{
			onError: (err: AxiosError) => {
				console.error(err.response);
				if (err.response?.status === 401) {
					history.push(`/signin?redirect=studentlive/${_id}`);
				}
			},
			onSuccess: ({ data }) => {
				console.log(data);
				setEnrolledStudents &&
					setEnrolledStudents(data.totalStudentsWhoEnrolled);
				changeExamState && changeExamState(data.examStatus);
				changeExamData &&
					changeExamData({
						courseName: data.courseName,
						examName: data.examName,
					});

				if (data.examDate) {
					const date = new Date(data.examDate);
					const dateString = date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "long",
						day: "numeric",
					});
					changeExamDate && changeExamDate(dateString);
				}
			},
		}
	);

	useQuery(
		["get-socket-data", _id],
		() =>
			axios.get<
				Array<{
					userId: string;
					name: string;
					email: string;
				}>
			>(`${SOCKET_DATA}?examId=${_id}`),
		{
			refetchInterval: 5000,
			onSuccess: (data) => {
				setLiveStudents(data.data.length);

				let live_data = data.data.map((val) => ({
					_id: val.userId,
					user: {
						firstName: val.name,
						email: val.email,
					},
				}));

				setLiveStudentData(live_data);
			},
		}
	);

	const { isLoading: submitted_data_loading } = useQuery(
		["get-submitted-exam-results", _id],
		() =>
			developAxios(localStorage.getItem("token") || "").get<{
				result: Array<{
					_id: string;
					user: {
						email: string;
						firstName: string;
					};
				}>;
			}>("/hybrid-exam/getSubmittedUserByExamId/" + _id),
		{
			refetchInterval: 20000,
			onSuccess: ({ data }) => {
				let submitted_data: Array<{
					user: {
						email: string;
						firstName: string;
					};
					_id: string;
					status: "submitted";
				}> = data.result.map((val) => ({
					...val,
					status: "submitted",
				}));
				console.log(data.result.length, "getSubmittedUserByExamId");
				setSubmittedUsers(data.result.length);
				setSubmittedData(submitted_data);
			},
		}
	);

	const { isLoading: unsubmitted_loading } = useQuery(
		["getUnsubmittedUsers", _id],
		() =>
			developAxios(localStorage.getItem("token") || "").get<
				Array<{
					_id: string;
					email: string;
					firstName: string;
					lastName: string;
				}>
			>(`/hybrid-exam/getUnSubmittedUserByExamId/${_id}`),
		{
			refetchInterval: 20000,
			onSuccess: ({ data }) => {
				let unsubmitted_users: Array<{
					user: {
						firstName: string;
						email: string;
					};
					_id: string;
					status: "unsubmitted";
				}> = data.map((val) => ({
					user: {
						firstName: val.firstName,
						email: val.email,
					},
					_id: val._id,
					status: "unsubmitted",
				}));

				setUnsubmittedData(unsubmitted_users);
			},
		}
	);

	function getData(): {
		students:
			| Array<{
					user: {
						firstName?: string;
						email: string;
					};
					_id: string;
			  }>
			| undefined;
		isLoading: boolean;
		status?: "live" | "submitted" | "unsubmitted";
	} {
		switch (tab) {
			case 2:
				return {
					students: submittedData,
					isLoading: submitted_data_loading,
					status: "submitted",
				};

			case 3:
				return {
					students: unsubmittedData,
					isLoading: unsubmitted_loading,
					status: "unsubmitted",
				};

			default:
				return {
					students: liveStudentData,
					isLoading: false,
				};
		}
	}

	if (tab === 4) {
		return (
			<AllStudents
				students={[
					...liveStudentData,
					...submittedData,
					...unsubmittedData,
				]}
				searchValue={searchValue}
			/>
		);
	}

	return <LiveStudents {...getData()} searchValue={searchValue} />;
}

ActiveTab.defaultProps = {
	setLiveStudents: (count: number) => {},
	setEnrolledStudents: (count: number) => {},
	setSubmittedUsers: (count: number) => {},
	changeExamDate: (date: string) => {},
	changeExamState: (status: "live" | "ended") => {},
	changeExamData: (options: { courseName: string; examName: string }) => {},
};
